import React, { useEffect } from 'react';
import { getShowCriticalMissed } from '@pharmaplan/common';
import toast from 'react-hot-toast';
import MissedCriticalNotification from '../../components/ToastNotification/MissedCriticalNotification';
import { useAppSelector } from '../useAppSelector';
import ThemeConstants from '../../theme/ThemeConstants';

const useShowCriticialNotification = (showNotification: () => void) => {
  const displayCriticalNotification = useAppSelector(getShowCriticalMissed);
  useEffect(() => {
    if (displayCriticalNotification) {
      toast(
        (t) =>
          (
            <MissedCriticalNotification
              onClick={showNotification}
              toastParams={t}
            />
          ),
        {
          duration: Infinity,
          style: {
            backgroundColor: ThemeConstants.eventChip.booked,
            width: '100%',
            maxWidth: 700,
          },
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayCriticalNotification]);
};

export default useShowCriticialNotification;
